// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-row[data-v-d16e54f0]{grid-template-columns:repeat(3,1fr)}.invalid-input-text[data-v-d16e54f0]{position:relative}@media(max-width:480px){.invalid-input-text[data-v-d16e54f0]{position:static}.invalid-input-text[data-v-d16e54f0]:after{top:0;transform:translateY(-25%)}}", ""]);
// Exports
module.exports = exports;
